import * as z from "zod";

const FileContentSchema_ = z.object({
  fileName: z.string(),
  s3Url: z.string(),
  headers: z.array(z.string()),
  sampleRows: z.array(z.record(z.string(), z.string())),
  totalRowCount: z.number(),
});

export const addFilesToIntelligentInventoryThread = {
  name: "addFilesToIntelligentInventoryThread" as const,
  input: z.object({
    threadId: z.string(),
    fileContents: z.array(FileContentSchema_),
  }),
  output: z.object({}),
};
